import React from 'react';
import Flatpickr from 'react-flatpickr';

import { COMMON_CONST } from '../../constants/constants';

class NowDatePicker extends React.Component {
  static defaultProps = {
    enableTime: false,
    isDisabled: false,
    width: 'inherit',
  };

  render() {
    const {
      value,
      onChange,
      options,
      enableTime,
      isDisabled,
      className,
      dateFormat = COMMON_CONST.FormatDateTypeView,
      width,
      ...rest
    } = this.props;
    return (
      <Flatpickr
        className={`form-control ${className}`}
        options={{
          dateFormat,
          enableTime,
          ...options,
        }}
        value={value}
        onChange={onChange}
        style={{
          background: isDisabled ? '#eee' : '#fff',
          height: 38,
          width,
        }}
        {...rest}
      />
    );
  }
}

export default NowDatePicker;



// WEBPACK FOOTER //
// ./foody/src/components/Common/NowDatePicker.jsx